export default "__VITE_ASSET__p3WjyhE2__"